<button
class="btn btn-primary btn-sm py-1 fw-light shadow me-2"
  (click)="share()">
  <i class="bi bi-facebook"></i> Share
</button>